//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
import "../no/SelectViewList.js";
import "../Drawings/Drawings.SelectDraftingViewList.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ConfigurationFile",1,0],[0,"OpenConvertedPmiDestinationPart",1,0],[1,"SelectDraftingSheet",0,"SelectViewList",0],[1,"SelectDraftingView",0,"Drawings.SelectDraftingViewList",0],[1,"SelectObjectsToConvert",0,"SelectNXObjectList",0],[0,"SelectionType",1,0],[0,"SettingsBuilder",0,"Drawings.SettingsBuilder",0],[0,"UseContextAssembly",1,0]],[[["contextAssembly"],"SetContextAssembly",{},1,0]],[]];
SPLM.Drawings.ConvertDraftingContentsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.ConvertDraftingContentsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.ConvertDraftingContentsBuilder.SelectConversionEntityType = Object.freeze({
    "Drawing" : "Drawing", "Sheet" : "Sheet", "View" : "View", "Annotation" : "Annotation"});

export default SPLM;